import type { Localization } from '@/payload-types'

export const translationsData = {
  navbar: {
    home: { en: 'Home', fr: 'maison', ar: 'الرئيسية' },
    catalogue: { en: 'Catalogue', fr: 'Catalogue', ar: 'الكتالوج' },
    products: { en: 'Products', fr: 'Produits', ar: 'المنتجات' },
    news: { en: 'News', fr: 'Actualités', ar: 'الأخبار' },
    dealership: { en: 'Dealership', fr: 'Concession', ar: 'الوكالات' },
    contact: { en: 'Contact', fr: 'Contact', ar: 'اتصال' },
    'contact us': { en: 'Contact Us', fr: 'Contactez-nous', ar: 'اتصل بنا' },
    about: { en: 'About', fr: 'À propos', ar: 'عن' },
    'about us': { en: 'About Us', fr: 'À propos de nous', ar: 'معلومات عنا' },
    blog: { en: 'Blog', fr: 'Blog', ar: 'المدونة' },
    insight: { en: 'Insight', fr: 'Connaissances', ar: 'الرؤى' },
    insights: { en: 'Insights', fr: 'Connaissances', ar: 'الرؤى' },
    pricing: { en: 'Pricing', fr: 'Tarifs', ar: 'التسعير' },
  },
  hero: {
    aboutTitle: { en: 'BEHIND THE BUILD', fr: 'DERRIÈRE LA CONSTRUCTION', ar: 'خلف البناء' },
    aboutBreadcrumb: { en: 'HOME / ABOUT', fr: 'maison/À PROPOS', ar: 'الرئيسية/معلومات عنا' },
    contactTitle: { en: 'CONTACT US', fr: 'CONTACTEZ-NOUS', ar: 'اتصل بنا' },
    contactBreadcrumb: {
      en: 'HOME / CONTACT US',
      fr: 'maison/CONTACTEZ-NOUS',
      ar: 'الرئيسية/اتصل بنا',
    },
    productsTitle: { en: 'PRODUCTS', fr: 'PRODUITS', ar: 'المنتجات' },
    productsBreadcrumb: {
      en: 'HOME / PRODUCTS',
      fr: 'maison / PRODUITS',
      ar: 'الرئيسية/المنتجات',
    },
    insightsTitle: { en: 'INSIGHTS', fr: 'ANALYSES', ar: 'رؤى' },
    insightsBreadcrumb: { en: 'HOME / BLOG', fr: 'maison / BLOG', ar: 'الرئيسية / المدونة' },
    enquiryTitle: { en: 'ENQUIRY CART', fr: 'PANIER DE DEMANDE', ar: 'سلة الاستفسارات' },
    enquiryBreadcrumb: {
      en: 'HOME / ENQUIRY CART',
      fr: 'maison / PANIER DE DEMANDE',
      ar: 'الرئيسية / سلة الاستفسارات',
    },
    dealerTitle: { en: 'DEALER CART', fr: 'PANIER DISTRIBUTEUR', ar: 'سلة الوكلاء' },
    dealerBreadcrumb: {
      en: 'HOME / DEALER CART',
      fr: 'maison / PANIER DISTRIBUTEUR',
      ar: 'الرئيسية / سلة الوكلاء',
    },
    privacyTitle: {
      en: 'PRIVACY POLICY',
      fr: 'POLITIQUE DE CONFIDENTIALITÉ',
      ar: 'سياسة الخصوصية',
    },
    privacyBreadcrumb: {
      en: 'HOME / PRIVACY POLICY',
      fr: 'maison / POLITIQUE DE CONFIDENTIALITÉ',
      ar: 'الرئيسية / سياسة الخصوصية',
    },
    tandcTitle: { en: 'TERMS & CONDITIONS', fr: 'TERMES ET CONDITIONS', ar: 'الشروط والأحكام' },
    tandcBreadcrumb: {
      en: 'HOME / TERM AND CONDITIONS',
      fr: 'maison / TERMES ET CONDITIONS',
      ar: 'الرئيسية / الشروط والأحكام',
    },
  },
  common: {
    home: { en: 'Home', fr: 'maison', ar: 'الرئيسية' },
    cart: { en: 'Cart', fr: 'Panier', ar: 'السلة' },
    dashboard: { en: 'Dashboard', fr: 'Tableau de bord', ar: 'لوحة التحكم' },
    login: { en: 'Login', fr: 'Connexion', ar: 'تسجيل الدخول' },
    logout: { en: 'Logout', fr: 'Déconnexion', ar: 'تسجيل الخروج' },
    language: { en: 'Language', fr: 'langue', ar: 'لغة' },
    shop_now: { en: 'Shop Now', fr: 'Achetez maintenant', ar: 'تسوق الآن' },
    search: { en: 'Search', fr: 'Recherche', ar: 'يبحث' },
    our_products: { en: 'Our Products', fr: 'Nos produits', ar: 'منتجاتنا' },
    view_projects: { en: 'View Projects', fr: 'Voir les projets', ar: 'عرض المشاريع' },
    products_headline_line1: {
      en: 'Engineered filtration solutions',
      fr: 'Solutions de filtration sur mesure',
      ar: 'حلول ترشيح هندسية',
    },
    products_headline_line2: {
      en: 'Across every application',
      fr: 'Pour toute application',
      ar: 'في كل التطبيقات',
    },
    yoe: { en: 'Years of Experience', fr: "Années d'expérience", ar: ' سنوات من الخبرة' },
    varieties: { en: 'Varieties of Filters', fr: 'Variétés de filtres', ar: 'أنواع المرشحات' },
    quick_links: { en: 'Quick Links', fr: 'Liens rapides', ar: 'روابط سريعة' },
    follow_us: { en: 'Follow Us', fr: 'Suivez-nous', ar: 'تابعنا' },
    newsletter_signup: {
      en: 'Sign up for Newsletter',
      fr: 'Inscrivez-vous à la newsletter',
      ar: '  اشترك في النشرة الإخبارية',
    },
    subscribe_us: { en: 'Subscribe Us', fr: 'Abonnez-vous', ar: 'اشترك معنا' },
    explore_our_filters: {
      en: 'EXPLORE OUR WIDE RANGE OF FILTERS',
      fr: 'EXPLOREZ NOTRE VASTE GAMME DE FILTRES',
      ar: 'استكشف مجموعتنا الواسعة من المرشحات',
    },
    open_menu: { en: 'Open menu', fr: 'Ouvrir le menu', ar: 'افتح القائمة' },
    close_menu: { en: 'Close menu', fr: 'Fermer le menu', ar: 'إغلاق القائمة' },
    open_account_menu: {
      en: 'Open account menu',
      fr: 'Ouvrir le menu du compte',
      ar: 'افتح قائمة الحساب',
    },
    close_account_menu: {
      en: 'Close account menu',
      fr: 'Fermer le menu du compte',
      ar: 'إغلاق قائمة الحساب',
    },
    mobile_navigation: {
      en: 'Mobile navigation',
      fr: 'Navigation mobile',
      ar: 'التنقل عبر الجوال',
    },
    logout_success: {
      en: 'Logged out successfully',
      fr: 'Déconnexion réussie',
      ar: 'تم تسجيل الخروج بنجاح',
    },
    search_prompt: {
      en: 'Looking for a filter, an application, an accessory?',
      fr: 'Vous recherchez un filtre, une application, un accessoire ?',
      ar: 'هل تبحث عن فلتر أو تطبيق أو ملحق؟',
    },
    search_hint: {
      en: 'Search by reference, name, or brand',
      fr: 'Recherchez par référence, nom ou marque',
      ar: 'ابحث حسب المرجع أو الاسم أو العلامة التجارية',
    },
    search_placeholder: {
      en: 'Reference, name, brand...',
      fr: 'Référence, nom, marque...',
      ar: 'المرجع، الاسم، العلامة التجارية...',
    },
    search_length_validation: {
      en: 'Please enter at least 4 characters for search.',
      fr: 'Veuillez saisir au moins 4 caractères pour la recherche.',
      ar: 'يرجى إدخال 4 أحرف على الأقل للبحث.',
    },
    search_desc: {
      en: 'Enter a product reference, name, or brand to search.',
      fr: 'Entrez une référence produit, un nom ou une marque pour rechercher.',
      ar: 'أدخل مرجع المنتج أو اسمه أو علامته التجارية للبحث.',
    },
    search_no_results_description: {
      en: `Try using a different keyword or search type. \n If you believe the item is missing from our catalog, please fill out the contact form with the relevant details`,
      fr: `Essayez un autre mot-clé ou un autre type de recherche. \n Si vous pensez que l'article est absent de notre catalogue, veuillez remplir le formulaire de contact avec les informations nécessaires.`,
      ar: `جرّب استخدام كلمة مفتاحية أو نوع بحث مختلف.
\n
إذا كنت تعتقد أن المنتج غير موجود في كتالوجنا، يُرجى ملء نموذج الاتصال بالمعلومات المطلوبة.`,
    },
    dimensions_config_error: {
      en: 'Failed to load dimensions configuration. Please try again later',
      fr: 'Échec du chargement de la configuration des dimensions. Veuillez réessayer plus tard.',
      ar: 'فشل في تحميل إعدادات الأبعاد. يرجى المحاولة مرة أخرى لاحقاً',
    },
    email_address: { en: 'Email address', fr: 'Adresse e-mail', ar: 'عنوان البريد الإلكتروني' },
    all_rights_reserved: {
      en: 'All Rights Reserved',
      fr: 'Tous droits réservés',
      ar: 'جميع الحقوق محفوظة',
    },
    privacy_policy: {
      en: 'Privacy Policy',
      fr: 'Politique de confidentialité',
      ar: 'سياسة الخصوصية',
    },
    terms_and_conditions: {
      en: 'Terms & Conditions',
      fr: 'Conditions générales',
      ar: 'الشروط والأحكام',
    },
    subscribe_to_newsletter: {
      en: 'Subscribe to newsletter',
      fr: "S'abonner à la newsletter",
      ar: 'اشترك في النشرة الإخبارية',
    },
    newsletter_blurb: {
      en: "To stay updated on our latest products, news and trends. Don't worry, we won't spam you!",
      fr: 'Pour rester informé de nos derniers produits, actualités et tendances. Ne vous inquiétez pas, nous ne vous enverrons pas de spam !',
      ar: 'للبقاء على اطلاع بآخر منتجاتنا وأخبارنا واتجاهاتنا. لا تقلق، لن نرسل لك رسائل مزعجة!',
    },
    subscribe_us_title: { en: 'SUBSCRIBE US!', fr: 'ABONNEZ-VOUS !', ar: 'اشترك معنا!' },
    subscribe_button: { en: 'SUBSCRIBE', fr: "S'ABONNER", ar: 'اشترك' },
    subscribing: { en: 'Subscribing...', fr: 'Abonnement...', ar: 'جارٍ الاشتراك...' },
    subscribe_success: {
      en: 'Thank you for subscribing.',
      fr: 'Merci de vous être abonné.',
      ar: 'شكرًا لاشتراكك.',
    },
    subscribe_already_subscribed: {
      en: 'This email is already subscribed.',
      fr: 'Cette adresse e-mail est déjà inscrite.',
      ar: 'هذا البريد الإلكتروني مشترك بالفعل.',
    },
    subscribe_resubscribed: {
      en: 'Thank you for re-subscribing.',
      fr: 'Merci pour votre réinscription.',
      ar: 'شكرًا لإعادة اشتراكك.',
    },
    subscribe_failed: {
      en: 'Failed to subscribe. Please try again.',
      fr: "Échec de l'inscription. Veuillez réessayer.",
      ar: 'فشل الاشتراك. يرجى المحاولة مرة أخرى.',
    },
    email_required: {
      en: 'Please enter your email address.',
      fr: 'Veuillez saisir votre adresse e-mail.',
      ar: 'يرجى إدخال عنوان بريدك الإلكتروني.',
    },
    valid_email_required: {
      en: 'Please enter a valid email',
      fr: 'Veuillez saisir une adresse e-mail valide.',
      ar: 'يُرجى إدخال بريد إلكتروني صالح.',
    },
    generic_error: {
      en: 'Something went wrong.',
      fr: "Une erreur s'est produite.",
      ar: 'حدث خطأ ما.',
    },
    turnstile_required: {
      en: 'Please complete the security verification before submitting.',
      fr: 'Veuillez compléter la vérification de sécurité avant de soumettre.',
      ar: 'يرجى إكمال التحقق الأمني قبل الإرسال.',
    },
    turnstile_failed: {
      en: 'Security verification failed. Please try again.',
      fr: 'La vérification de sécurité a échoué. Veuillez réessayer.',
      ar: 'فشل التحقق الأمني. يرجى المحاولة مرة أخرى.',
    },
    browse_products: { en: 'Browse Products', fr: 'Parcourir les produits', ar: 'تصفح المنتجات' },
    download_ecatalogue: {
      en: 'Download E-Catalogue',
      fr: 'Télécharger le catalogue',
      ar: 'تنزيل الكتالوج الإلكتروني',
    },
    catalogue_not_available: {
      en: 'E-Catalogue Not Available',
      fr: 'E-Catalogue non disponible',
      ar: 'الكتالوج الإلكتروني غير متوفر',
    },
    loading: { en: 'Loading...', fr: 'Chargement...', ar: 'جارٍ التحميل...' },
    loading_search_results: {
      en: 'Loading search results...',
      fr: 'Chargement des résultats de recherche...',
      ar: 'جارٍ تحميل نتائج البحث...',
    },
    failed_load_search_results: {
      en: 'Failed to load search results',
      fr: 'Échec du chargement des résultats de recherche',
      ar: 'فشل تحميل نتائج البحث',
    },
    provide_search_keyword: {
      en: 'Please provide a search keyword to get results',
      fr: 'Veuillez fournir un mot-clé pour obtenir des résultats',
      ar: 'يرجى إدخال كلمة بحث للحصول على النتائج',
    },
    loading_products: {
      en: 'Loading products...',
      fr: 'Chargement des produits...',
      ar: 'جارٍ تحميل المنتجات...',
    },
    failed_load_products_reconnect: {
      en: 'Failed to load products. Please reconnect and try again.',
      fr: 'Échec du chargement des produits. Veuillez vous reconnecter et réessayer.',
      ar: 'فشل تحميل المنتجات. يرجى إعادة الاتصال والمحاولة مرة أخرى.',
    },
    search_results: { en: 'Search results', fr: 'Résultats de recherche', ar: 'نتائج البحث' },
    clear_results: { en: 'Clear results', fr: 'Effacer les résultats', ar: 'مسح النتائج' },
    showing_results: { en: 'Showing', fr: 'Affichage', ar: 'عرض' },
    of_results: { en: 'of', fr: 'sur', ar: 'من' },
    sort_by: { en: 'Sort by:', fr: 'Trier par :', ar: 'ترتيب حسب:' },
    most_popular: { en: 'Most Popular', fr: 'Les plus populaires', ar: 'الأكثر شيوعًا' },
    price_low_to_high: {
      en: 'Price: Low to High',
      fr: 'Prix : croissant',
      ar: 'السعر: من الأقل إلى الأعلى',
    },
    price_high_to_low: {
      en: 'Price: High to Low',
      fr: 'Prix : décroissant',
      ar: 'السعر: من الأعلى إلى الأقل',
    },
    no_insights_yet: {
      en: 'No insights yet.',
      fr: 'Aucun article pour le moment.',
      ar: 'لا توجد مقالات بعد.',
    },
    search_type: { en: 'Search Type', fr: 'Type de recherche', ar: 'نوع البحث' },
    smart_search: { en: 'Smart Search', fr: 'Recherche intelligente', ar: 'بحث ذكي' },
    cross_reference: { en: 'Cross Reference', fr: 'Référence croisée', ar: 'مرجع متقاطع' },
    dimension_search: {
      en: 'Dimension Search',
      fr: 'Recherche par dimensions',
      ar: 'بحث بالأبعاد',
    },
    filter_type: { en: 'Filter Type', fr: 'Type de filtre', ar: 'نوع الفلتر' },
    filter_shape: { en: 'Filter Shape', fr: 'Forme du filtre', ar: 'شكل الفلتر' },
    select_filter_type_shape: {
      en: 'Select filter type and shape',
      fr: 'Sélectionnez le type et la forme du filtre',
      ar: 'اختر نوع الفلتر وشكله',
    },
    tolerance: { en: 'Tolerance', fr: 'Tolérance', ar: 'التفاوت' },
    reset: { en: 'RESET', fr: 'RÉINITIALISER', ar: 'إعادة تعيين' },
    no_data_available: {
      en: 'No data available.',
      fr: 'Aucune donnée disponible.',
      ar: 'لا توجد بيانات متاحة.',
    },
    physical_dimensions: {
      en: 'Physical dimensions',
      fr: 'Dimensions physiques',
      ar: 'الأبعاد الفيزيائية',
    },
    thread_size: { en: 'Thread size', fr: 'Taille du filetage', ar: 'حجم القلاوظ' },
    center_tube_diameter: {
      en: 'Center tube diameter',
      fr: 'Diamètre du tube central',
      ar: 'قطر الأنبوب المركزي',
    },
    vehicle_applications: {
      en: 'Machine / applications',
      fr: 'Machine / applications',
      ar: 'الآلة / التطبيقات',
    },
    legal_informations: {
      en: 'Legal informations',
      fr: 'Informations légales',
      ar: 'المعلومات القانونية',
    },
    model_type: { en: 'Model type', fr: 'Type de modèle', ar: 'نوع الموديل' },
    engine_code: { en: 'Engine code', fr: 'Code moteur', ar: 'رمز المحرك' },
    year: { en: 'Year', fr: 'Année', ar: 'السنة' },
    machine_make: { en: 'Machine make', fr: 'Marque de la machine', ar: 'ماركة الماكينة' },
    machine_model: { en: 'Machine model', fr: 'مودèle de la machine', ar: 'موديل الماكينة' },
    equipment_make: { en: 'Equipment make', fr: "Marque de l'équipement", ar: 'ماركة المعدات' },
    equipment_model: { en: 'Equipment model', fr: "Modèle de l'équipement", ar: 'موديل المعدات' },
    no_image: { en: 'No image', fr: 'Pas d’image', ar: 'لا توجد صورة' },
    new_arrivals: { en: 'New Arrivals', fr: 'Nouveautés', ar: 'وصل حديثًا' },
    you_are_offline: { en: 'You are offline', fr: 'Vous êtes hors ligne', ar: 'أنت غير متصل' },
    offline_message: {
      en: 'No internet connection detected. You can still browse pages you have already visited in Gallium Filters.',
      fr: 'Aucune connexion Internet détectée. Vous pouvez toujours parcourir les pages déjà visitées sur Gallium Filters.',
      ar: 'لم يتم اكتشاف اتصال بالإنترنت. لا يزال بإمكانك تصفح الصفحات التي زرتها مسبقًا في Gallium Filters.',
    },
    try_again: { en: 'Try Again', fr: 'Réessayer', ar: 'حاول مرة أخرى' },
  },
  toastMessages: {
    required_field_missing: {
      en: 'Please fill the required fields to search',
      fr: 'Veuillez remplir les champs obligatoires pour effectuer une recherche.',
      ar: 'يُرجى ملء الحقول المطلوبة للبحث.',
    },
    new_app_version_available: {
      en: '🆕 New app version available!',
      fr: "🆕 Nouvelle version de l'application disponible !",
      ar: '🆕 تتوفر نسخة جديدة من التطبيق!',
    },
    clear_stored_data_description: {
      en: 'Clear stored data and refresh? Your current session data will be lost.',
      fr: 'Effacer les données enregistrées et actualiser ? Vos données de session actuelles seront perdues.',
      ar: 'هل تريد مسح البيانات المحفوظة وإعادة التحميل؟ سيتم فقدان بيانات الجلسة الحالية.',
    },
    clear_and_update: {
      en: 'Clear & Update',
      fr: 'Effacer & Mettre à jour',
      ar: 'مسح وتحديث',
    },
    later: {
      en: 'Later',
      fr: 'Plus tard',
      ar: 'لاحقًا',
    },
    loginToSearch: {
      en: 'Please log in to use dimension search.',
      fr: 'Veuillez vous connecter pour utiliser la recherche par dimensions.',
      ar: 'يرجى تسجيل الدخول لاستخدام البحث حسب الأبعاد.',
    },
  },
  auth: {
    common: {
      email_address: {
        en: 'Email address',
        fr: 'Adresse e-mail',
        ar: 'البريد الإلكتروني',
      },
      password: {
        en: 'Password',
        fr: 'Mot de passe',
        ar: 'كلمة المرور',
      },
      forgot_password: {
        en: 'FORGOT PASSWORD',
        fr: 'MOT DE PASSE OUBLIÉ',
        ar: 'نسيت كلمة المرور',
      },
      login: {
        en: 'LOG IN',
        fr: 'SE CONNECTER',
        ar: 'تسجيل الدخول',
      },
      send: {
        en: 'SEND',
        fr: 'ENVOYER',
        ar: 'إرسال',
      },
      sending: {
        en: 'Sending…',
        fr: 'Envoi…',
        ar: 'جارٍ الإرسال…',
      },
      back_to_login: {
        en: 'BACK TO LOGIN',
        fr: 'RETOUR À LA CONNEXION',
        ar: 'العودة لتسجيل الدخول',
      },
      unable_to_connect: {
        en: 'Unable to connect. Please check your connection and try again.',
        fr: 'Impossible de se connecter. Vérifiez votre connexion et réessayez.',
        ar: 'تعذر الاتصال. يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
      },
    },

    login: {
      welcome_back: {
        en: 'WELCOME BACK',
        fr: 'BON RETOUR',
        ar: 'مرحبًا بعودتك',
      },
      logging_in: {
        en: 'Logging in…',
        fr: 'Connexion…',
        ar: 'جارٍ تسجيل الدخول…',
      },
      invalid_email_or_password: {
        en: 'Invalid email or password.',
        fr: 'Adresse e-mail ou mot de passe invalide.',
        ar: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
      },
      login_successful: {
        en: 'Login successful!',
        fr: 'Connexion réussie !',
        ar: 'تم تسجيل الدخول بنجاح!',
      },
      login_saved_failed: {
        en: 'Login succeeded but session could not be saved. Please try again.',
        fr: "Connexion réussie mais la session n'a pas pu être enregistrée. Veuillez réessayer.",
        ar: 'نجح تسجيل الدخول ولكن تعذر حفظ الجلسة. يرجى المحاولة مرة أخرى.',
      },
    },

    forgot_password: {
      forgot_password: {
        en: 'FORGOT PASSWORD',
        fr: 'MOT DE PASSE OUBLIÉ',
        ar: 'نسيت كلمة المرور',
      },
      instruction: {
        en: 'ENTER THE EMAIL YOU USED TO CREATE YOUR ACCOUNT SO WE CAN SEND YOU INSTRUCTIONS ON HOW TO RESET YOUR PASSWORD.',
        fr: "ENTREZ L'ADRESSE E-MAIL UTILISÉE POUR CRÉER VOTRE COMPTE AFIN QUE NOUS PUISSIONS VOUS ENVOYER LES INSTRUCTIONS DE RÉINITIALISATION.",
        ar: 'أدخل البريد الإلكتروني الذي استخدمته لإنشاء حسابك حتى نرسل لك تعليمات إعادة تعيين كلمة المرور.',
      },
      email_address_upper: {
        en: 'EMAIL ADDRESS',
        fr: 'ADRESSE E-MAIL',
        ar: 'البريد الإلكتروني',
      },
    },

    check_email: {
      check_your_email: {
        en: 'CHECK YOUR EMAIL',
        fr: 'VÉRIFIEZ VOTRE E-MAIL',
        ar: 'تحقق من بريدك الإلكتروني',
      },
      generic_message: {
        en: 'IF AN ACCOUNT EXISTS FOR THAT EMAIL, WE SENT PASSWORD RESET INSTRUCTIONS. CHECK YOUR INBOX.',
        fr: 'SI UN COMPTE EXISTE POUR CET E-MAIL, NOUS AVONS ENVOYÉ LES INSTRUCTIONS DE RÉINITIALISATION. VÉRIFIEZ VOTRE BOÎTE DE RÉCEPTION.',
        ar: 'إذا كان هناك حساب لهذا البريد الإلكتروني، فقد أرسلنا تعليمات إعادة تعيين كلمة المرور. تحقق من صندوق الوارد.',
      },
      sent_to_message_prefix: {
        en: 'WE HAVE SENT AN EMAIL WITH PASSWORD RESET INFORMATION TO',
        fr: 'NOUS AVONS ENVOYÉ UN E-MAIL AVEC LES INFORMATIONS DE RÉINITIALISATION À',
        ar: 'لقد أرسلنا بريدًا إلكترونيًا يحتوي على معلومات إعادة التعيين إلى',
      },
      email_sent_again: {
        en: 'Email sent again.',
        fr: 'E-mail renvoyé.',
        ar: 'تم إرسال البريد مرة أخرى.',
      },
      sending: {
        en: 'Sending…',
        fr: 'Envoi…',
        ar: 'جارٍ الإرسال…',
      },
      resend_in: {
        en: 'Resend in',
        fr: 'Renvoyer dans',
        ar: 'إعادة الإرسال خلال',
      },
      resend_email: {
        en: 'RESEND EMAIL',
        fr: "RENVOYER L'E-MAIL",
        ar: 'إعادة إرسال البريد',
      },
    },

    reset_password: {
      reset_password: {
        en: 'RESET PASSWORD',
        fr: 'RÉINITIALISER LE MOT DE PASSE',
        ar: 'إعادة تعيين كلمة المرور',
      },
      invalid_link_message: {
        en: 'Invalid or expired reset link. Please request a new password reset link.',
        fr: 'Lien de réinitialisation invalide ou expiré. Veuillez demander un nouveau lien de réinitialisation.',
        ar: 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد لإعادة تعيين كلمة المرور.',
      },
      resend_reset_link: {
        en: 'RESEND RESET LINK',
        fr: 'RENVOYER LE LIEN',
        ar: 'إعادة إرسال رابط التعيين',
      },

      resetting: {
        en: 'Resetting ...',
        fr: 'Réinitialisation...',
        ar: 'جاري إعادة الضبط...',
      },
      fill_both_field: {
        en: 'Please fill in both password fields.',
        fr: 'Veuillez remplir les deux champs de mot de passe.',
        ar: 'يُرجى ملء حقلي كلمة المرور.',
      },
      passwords_not_match: {
        en: 'Passwords do not match.',
        fr: 'Les mots de passe ne correspondent pas.',
        ar: 'كلمتا المرور غير متطابقتين',
      },
      _field: {
        en: '',
        fr: '',
        ar: '',
      },
    },

    reset_success: {
      title: {
        en: 'PASSWORD RESET SUCCESSFULLY',
        fr: 'MOT DE PASSE RÉINITIALISÉ AVEC SUCCÈS',
        ar: 'تمت إعادة تعيين كلمة المرور بنجاح',
      },
      subtitle: {
        en: 'YOU CAN NOW LOG IN WITH YOUR NEW PASSWORD',
        fr: 'VOUS POUVEZ MAINTENANT VOUS CONNECTER AVEC VOTRE NOUVEAU MOT DE PASSE',
        ar: 'يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة',
      },
    },
  },
}

export const responseMessages = {
  turnstile: {
    verificationFailed: {
      en: 'Security verification failed. Please try again.',
      fr: 'La vérification de sécurité a échoué. Veuillez réessayer.',
      ar: 'فشل التحقق الأمني. يرجى المحاولة مرة أخرى.',
    },
  },
  contact: {
    invalidRequestBody: {
      en: 'Invalid request body',
      fr: 'Corps de requête invalide',
      ar: 'نص الطلب غير صالح',
    },

    atLeastOneProductRequired: {
      en: 'At least one product is required.',
      fr: 'Au moins un produit est requis.',
      ar: 'مطلوب منتج واحد على الأقل.',
    },

    invalidProductLine: {
      en: 'One or more product lines are invalid.',
      fr: 'Une ou plusieurs lignes de produit sont invalides.',
      ar: 'هناك سطر أو أكثر من المنتجات غير صالح.',
    },

    fieldsRequired: {
      en: 'First name, last name, email, and message are required.',
      fr: "Le prénom, le nom, l'e-mail et le message sont obligatoires.",
      ar: 'الاسم الأول، واسم العائلة، والبريد الإلكتروني، والرسالة حقول مطلوبة.',
    },

    firstAndLastNameRequired: {
      en: 'First name and last name are required.',
      fr: 'Le prénom et le nom sont requis.',
      ar: 'الاسم الأول واسم العائلة مطلوبان.',
    },

    invalidName: {
      en: 'Name contains invalid characters.',
      fr: 'Le nom contient des caractères invalides.',
      ar: 'الاسم يحتوي على أحرف غير صالحة.',
    },

    invalidMessage: {
      en: 'Message is required and must be at least 10 characters.',
      fr: 'Le message est requis et doit contenir au moins 10 caractères.',
      ar: 'الرسالة مطلوبة ويجب أن تحتوي على 10 أحرف على الأقل.',
    },

    invalidEmail: {
      en: 'A valid email is required.',
      fr: 'Une adresse e-mail valide est requise.',
      ar: 'مطلوب بريد إلكتروني صالح.',
    },

    invalidPhoneNumber: {
      en: 'Invalid phone number.',
      fr: 'Numéro de téléphone invalide.',
      ar: 'رقم الهاتف غير صالح.',
    },

    invalidPhoneNumberForCountry: {
      en: 'Invalid phone number for {country}.',
      fr: 'Numéro de téléphone invalide pour {country}.',
      ar: 'رقم الهاتف غير صالح لـ {country}.',
    },

    invalidCompany: {
      en: 'Company name is required and must be between 2 and 80 characters.',
      fr: "Le nom de l'entreprise est requis et doit comporter entre 2 et 80 caractères.",
      ar: 'اسم الشركة مطلوب ويجب أن يكون بين 2 و 80 حرفًا.',
    },

    enquiryExists: {
      en: 'Enquiry for the item already in system. Your response will also be recorded',
      fr: 'Une demande pour cet article existe déjà dans le système. Votre réponse sera également enregistrée.',
      ar: 'يوجد بالفعل استفسار لهذا العنصر في النظام. سيتم أيضًا تسجيل ردك.',
    },

    enquirySubmitted: {
      en: 'Enquiry submitted successfully.',
      fr: 'Demande envoyée avec succès.',
      ar: 'تم إرسال الاستفسار بنجاح.',
    },

    failedToSendMessage: {
      en: 'Failed to send message. Please try again.',
      fr: "Échec de l'envoi du message. Veuillez réessayer.",
      ar: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
    },

    failedSubmission: {
      en: 'Failed to submit enquiry. Please try again.',
      fr: "Échec de l'envoi de la demande. Veuillez réessayer.",
      ar: 'فشل في إرسال الاستفسار. يرجى المحاولة مرة أخرى.',
    },

    stockRequestSubmitted: {
      en: 'Stock request submitted successfully.',
      fr: 'Demande de stock soumise avec succès.',
      ar: 'تم تقديم طلب المخزون بنجاح.',
    },

    waitBeforeSubmission: {
      en: 'Please wait a moment before submitting again.',
      fr: 'Veuillez patienter un instant avant de soumettre à nouveau.',
      ar: 'يُرجى الانتظار لحظة قبل إعادة الإرسال.',
    },
  },
}

export const getLocalizedTranslationData = (locale: AppLocale): Partial<Localization> => {
  return {
    navbar: Object.keys(translationsData.navbar).reduce(
      (acc, v) => ({
        ...acc,
        [v]: translationsData.navbar[v as keyof typeof translationsData.navbar]?.[locale],
      }),
      {} as Localization['navbar'],
    ),
    hero: Object.keys(translationsData.hero).reduce(
      (acc, v) => ({
        ...acc,
        [v]: translationsData.hero[v as keyof typeof translationsData.hero]?.[locale],
      }),
      {} as Localization['hero'],
    ),
    common: Object.keys(translationsData.common).reduce(
      (acc, v) => ({
        ...acc,
        [v]: translationsData.common[v as keyof typeof translationsData.common]?.[locale],
      }),
      {} as Localization['common'],
    ),
    toastMessages: Object.keys(translationsData.toastMessages).reduce(
      (acc, v) => ({
        ...acc,
        [v]: translationsData.toastMessages[v as keyof typeof translationsData.toastMessages]?.[
          locale
        ],
      }),
      {} as Localization['toastMessages'],
    ),
  }
}
